import { render } from "./EventPayoutPolicyEditor.vue?vue&type=template&id=37484909&scoped=true"
import script from "./EventPayoutPolicyEditor.vue?vue&type=script&lang=js"
export * from "./EventPayoutPolicyEditor.vue?vue&type=script&lang=js"

import "./EventPayoutPolicyEditor.vue?vue&type=style&index=0&id=37484909&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37484909"]])

export default __exports__